/**
 * Opens a stored file in a new tab.
 *
 * Certificates are *not* embedded. The storage host answers with framing
 * headers that forbid this origin, so an iframe pointed at a signed URL renders
 * the host's "This content is blocked" page instead of the file — which is how
 * every uploaded certificate became unreviewable on production (BI-1848). A
 * top-level navigation carries no such restriction, and it is what the old
 * dashboard has always done for documents.
 *
 * `noopener` severs `window.opener` on the opened tab, so a file host cannot
 * reach back into this one.
 */
export function openFileInNewTab(url: string | null | undefined): void {
  if (!url) return;
  window.open(url, '_blank', 'noopener,noreferrer');
}
